// removed by extract-text-webpack-plugin
module.exports = {"hidden":"In3-F","visuallyhidden":"_2i_jI","hide-text":"_32B0Q","center":"_3-If9","noprint":"QwtLS","root":"_3Ppfs","promoCode":"_1awE3","instructions":"_2ok1w","disclaimer":"_3AyMX"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/vg-gold-competition/default.scss
 ** module id = 1028
 ** module chunks = 2
 **/